import React from "react";
import { useNavigate } from "react-router-dom";

const OrderDiv = ({ order }) => {
    const navigate = useNavigate()
    const date = new Date(order.createdAt);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based, so add 1
    const day = date.getDate().toString().padStart(2, '0');
    const formattedDate = `${day}-${month}-${year}`;
    const openOrderDetails = () => {
        navigate(`order/${order._id}`);
    }
    return (
        <div>
            <div className="single-order-container" onClick={openOrderDetails}>

                <div className="single-order-leftside">
                    <div className="single-order-status t4 font-semibold">
                        {order.status}
                    </div>
                    <div className="single-order-itemcount t6 font-medium">
                        {order.products.length} Items
                    </div>
                    <div className="single-order-productimages">
                        {order.products.map(product => {
                            var defaultImageUrl;
                            if (product.product) {
                                defaultImageUrl = product.product.defaultImageUrl;
                            }
                            else {
                                defaultImageUrl = "https://static.zara.net/photos///2023/I/0/1/p/0761/352/251/2/w/576/0761352251_1_1_1.jpg?ts=1694605006090"
                            }
                            return (
                                <div className="col-lg-1 col-md-2 col-sm-4">
                                    <img
                                        className="single-order-productimage"
                                        src={defaultImageUrl}
                                        alt="Order Image"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/${product.product.name}/${product.product._id}`);
                                        }}
                                    />

                                </div>
                            )
                        })}
                    </div>
                    <div className="single-order-address t6">
                        <div className="font-medium">Shipping to:</div>
                        {order.customer?.name}
                        <br />
                        {order.customer?.addressLine1 + ", " + order.customer?.addressLine2 + ", " + order.customer?.state + ", " + order.customer?.city + " - " + order.customer?.postalCode}
                    </div>
                </div>

                <div className="single-order-rightside">
                    <div className="single-order-date t6 font-medium">
                        {formattedDate}
                    </div>
                    <div className="single-order-price t4 font-semibold">
                        ₹ {order.totalAmount}
                    </div>
                </div>
            </div>
            <hr className="myorders-line"></hr>
        </div>
    )
}

export default OrderDiv;